var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('ValueRow',{attrs:{"align":_vm.rowData.align(),"fontSize":_vm.rowData.fontSize()}},[_vm._v(" "+_vm._s(_vm.Contents.decode(_vm.rowData.value()))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }